<template>
  <div class="mine-page">
    <!-- 顶部用户信息区 -->
    <div class="header" :style="{ backgroundImage: 'url(/index_bg.png)' }">
      <!-- <div class="header-deco"></div> -->
      <div class="user-info">
        <div class="avatar">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="user-detail">
          <p class="user-line">组长：{{ userInfo.team ? userInfo.team.true_name + '(' + userInfo.team.mobile + ')' : '--'}}</p>
          <p class="user-line">姓名：{{ userInfo.true_name }}</p>
          <p class="user-line">电话：{{ maskedMobile }}</p>
        </div>
      </div>
    </div>

    <!-- 我的订单模块 -->
    <div class="module">
      <div class="module-title">
        <span class="title-bar"></span>
        <span>我的订单</span>
      </div>
      <div class="order-grid">
        <div
          v-for="item in orderTypes"
          :key="item.label"
          class="grid-item"
          @click="goOrders(item.value)"
        >
          <div class="grid-icon">
            <i :class="item.icon"></i>
          </div>
          <span class="grid-label">{{ item.label }}</span>
        </div>
      </div>
    </div>

    <!-- 常用功能模块 -->
    <div class="module">
      <div class="module-title">
        <span class="title-bar"></span>
        <span>常用功能</span>
      </div>
      <div class="func-grid">
        <div
          v-for="item in funcList"
          :key="item.label"
          class="grid-item"
          @click="handleFunc(item.label)"
        >
          <div class="grid-icon">
            <i :class="item.icon"></i>
          </div>
          <span class="grid-label">{{ item.label }}</span>
        </div>
      </div>
    </div>

    <TabBar />

    <!-- 退出登录确认弹窗 -->
    <div v-if="showLogoutConfirm" class="logout-mask" @click="showLogoutConfirm = false">
      <div class="logout-modal" @click.stop>
        <p class="logout-text">确定退出登录吗？</p>
        <div class="logout-btns">
          <button class="logout-btn cancel-btn" @click="showLogoutConfirm = false">取消</button>
          <button class="logout-btn confirm-btn" @click="confirmLogout">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar.vue'
import { getUserInfo, logout } from '@/utils/auth'
import { getSignUp, hzqLinkFile } from '@/api/order'

export default {
  name: 'Mine',
  components: { TabBar },
  data() {
    return {
      userInfo: getUserInfo(),
      orderTypes: [
        { label: '全部订单', icon: 'el-icon-back', value: 'all' },
        { label: '未接单', icon: 'el-icon-document', value: 0 },
        { label: '已接单', icon: 'el-icon-circle-check', value: 1 },
        { label: '服务中', icon: 'el-icon-time', value: 2 },
        { label: '已完成', icon: 'el-icon-circle-check', value: 3 }
      ],
      functions: [
        { label: '客服中心', icon: 'el-icon-service' },
        { label: '退出登录', icon: 'el-icon-switch-button' }
      ],
      showLogoutConfirm: false
    }
  },
  computed: {
    maskedMobile() {
      const m = this.userInfo.member_mobile
      if (!m || m.length < 7) return m || ''
      return m.slice(0, 3) + '****' + m.slice(-4)
    },
    funcList() {
      const list = [...this.functions]
      const signed = this.userInfo && this.userInfo.sign_wy_use_agreement_id > 0
      const contractItem = signed
        ? { label: '下载合同', icon: 'el-icon-document' }
        : { label: '签约合同', icon: 'el-icon-document' }
      // 插入到"退出登录"前面
      list.splice(list.length - 1, 0, contractItem)
      return list
    }
  },
  methods: {
    goOrders(type) {
      this.$router.push({ path: '/my-orders', query: { status: type } })
    },
    handleFunc(name) {
      if (name === '客服中心') {
        this.$router.push('/service-center')
      } else if (name === '下载合同') {
        this.handleDowloadContract()
      } else if (name === '签约合同') {
        this.handleOnlineContract()
      } else if (name === '退出登录') {
        this.showLogoutConfirm = true
      } else {
        this.$message.info(name + '功能开发中')
      }
    },
    async handleOnlineContract() {
      try {
        const res = await getSignUp()
        if (res.code === 0 && res.data && res.data.url) {
          window.location.href = res.data.url
        } else {
          this.$message.error(res.msg || '获取合同链接失败')
        }
      } catch (err) {
        this.$message.error(err.message || '获取合同链接失败')
      }
    },
    async handleDowloadContract() {
      try {
        const res = await hzqLinkFile()
        if (res.code === 0 && res.data && res.data.url) {
          window.location.href = res.data.url
        } else {
          this.$message.error(res.msg || '下载合同失败')
        }
      } catch (err) {
        this.$message.error(err.message || '下载合同失败')
      }
    },
    confirmLogout() {
      this.showLogoutConfirm = false
      logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.mine-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 56px;
}

/* 顶部用户信息 */
.header {
  position: relative;
  padding: 40px 20px 28px;
  overflow: hidden;
  height: 150px;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
}

.header-deco {
  position: absolute;
  top: -30px;
  right: -40px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.header-deco::before {
  content: '';
  position: absolute;
  bottom: 20px;
  left: -40px;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
}

.user-info {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 14px;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #ffd54f;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.avatar i {
  font-size: 36px;
  color: #fff;
}

.user-detail {
  flex: 1;
}

.user-line {
  font-size: 14px;
  color: #fff;
  line-height: 1.9;
}

/* 模块 */
.module {
  background: #fff;
  margin: 10px 0 0;
  padding: 16px 0;
}

.module:first-of-type {
  margin-top: 10px;
}

.module-title {
  display: flex;
  align-items: center;
  padding: 0 16px 14px;
}

.title-bar {
  width: 4px;
  height: 16px;
  background: #4a90e2;
  border-radius: 2px;
  margin-right: 8px;
  flex-shrink: 0;
}

.module-title > span:last-child {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* 图标网格 */
.order-grid {
  display: flex;
  justify-content: space-around;
  padding: 4px 8px 0;
}

.func-grid {
  display: flex;
  padding: 4px 16px 0;
}

.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  flex: 1;
}

.grid-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.grid-icon i {
  font-size: 26px;
  color: #4a90e2;
}

.grid-label {
  font-size: 12px;
  color: #666;
  text-align: center;
}

/* 退出登录弹窗 */
.logout-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.logout-modal {
  width: 80%;
  max-width: 320px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  animation: logout-in 0.25s ease;
}

@keyframes logout-in {
  from { transform: scale(0.85); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.logout-text {
  padding: 28px 20px 20px;
  text-align: center;
  font-size: 16px;
  color: #333;
}

.logout-btns {
  display: flex;
  border-top: 1px solid #eee;
}

.logout-btn {
  flex: 1;
  height: 48px;
  border: none;
  font-size: 16px;
  background: transparent;
  cursor: pointer;
}

.cancel-btn {
  color: #999;
  border-right: 1px solid #eee;
}

.cancel-btn:active {
  background: #f5f5f5;
}

.confirm-btn {
  color: #f5222d;
  font-weight: 500;
}

.confirm-btn:active {
  background: #fff1f0;
}
</style>
